import { Pipe, PipeTransform } from '@angular/core';
import { DatatableComponent } from './datatable.component';

@Pipe({
  name: 'stringToDate',
})
export class StringToDate implements PipeTransform {
  constructor(readonly datatable: DatatableComponent) {}
  transform(value: string | null | undefined): string {
    let year = value!.slice(0, 4);
    if (value!.slice(4, 8) === '0000') {
      return year;
    }

    let month = value!.slice(4, 6);
    let day = value!.slice(6, 8);

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    if (monthNames[parseInt(month) - 1] === undefined) {
      month = value!.slice(5, 7);
      day = value!.slice(8, 10);
    }
    let time = value!.substring(11, 19);

    const formattedDate = `${day} ${monthNames[parseInt(month) - 1]} ${parseInt(
      year
    )} ${time}`;
    return formattedDate;
  }
}
